<template>
  <div class="app-deactivate-auto-top-up-wrapper">
    <deactivate-auto-top-up
      v-if="showDeactivated"
      :auto-top-up="autoTopUp"
      :next-step="gotoSuccess"
    >
      <template #txtBeforeDeactivateAutoTopup><slot name="txtDeactivateBeforeAutoTopup"></slot></template>
      <template #txtBeforeActiveAutoTopup><slot name="txtDeactivateBeforeActiveAutoTopup"></slot></template>
      <template #txtActiveAutoTopUpDayOfMonth><slot name="txtDeactivateActiveAutoTopUpDayOfMonth"></slot></template>
      <template #txtActiveAutoTopUpAccountBalance><slot name="txtDeactivateActiveAutoTopUpAccountBalance"></slot></template>
      <template #lblDeaktivateAutoTopUp><slot name="lblDeaktivateAutoTopUp"></slot></template>
      <template #btnNext><slot name="btnDeactivateNext"></slot></template>
    </deactivate-auto-top-up>
    <Success v-if="showSuccess"
      :back="backToDeactivate"
    >
      <template #txtBefore><slot name="txtAutoTopUpSuccessDeactivated"></slot></template>
      <template #btnSuccessBack><slot name="btnAutoTopUpDeactivatedSuccessBack"></slot></template>
      <template #txtAfter><slot name="txtAutoTopUpSuccessDeactivatedAfter"></slot></template>
    </Success>
  </div>
</template>
<script>
import DeactivateAutoTopUp, { stepName as deactivateStepName } from './DeactivateAutoTopUp.vue'
import Success, { stepName as successStepName } from '../../../../generic/Success2.vue'
import { mapGetters, mapActions, mapMutations } from 'vuex'
export default {
  name: 'DeactivateAutoTopUpWrapper',
  data () {
    return {
      topUp: [],
      loading: false
    }
  },
  created () {
    this.setDeactivationView(deactivateStepName)
  },
  computed: {
    ...mapGetters('topUp', [
      'getDeactivationView'
    ]),
    gotoSuccess () {
      return successStepName
    },
    showDeactivated () {
      return this.getDeactivationView === deactivateStepName
    },
    showSuccess () {
      return this.getDeactivationView === successStepName
    }
  },
  methods: {
    backToDeactivate () {
      this.$emit('refresh')
    },
    activate () {
      this.loading = true
      this.changeAutoTopUp(this.topUp).then(() => {
        this.loading = false
      }, () => {
        this.loading = false
      })
    },
    ...mapActions('topUp', [
      'changeAutoTopUp'
    ]),
    ...mapMutations('topUp', [
      'setDeactivationView'
    ])
  },
  props:
    [
      'autoTopUp'
    ],
  components: { DeactivateAutoTopUp, Success }
}
</script>
